// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__aQRun","colMin":"styles_colMin__1VsZM"};